import React, { Component } from 'react';

export default class RedeemInvite extends Component {
  componentWillMount() {
    const { router, params, saveInviteHash } = this.props;
    saveInviteHash(params.hash);
    router.push('/register/');
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./registration/creative/components/redeem_invite.jsx